import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=075f0d8d&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('075f0d8d')) {
      api.createRecord('075f0d8d', component.options)
    } else {
      api.reload('075f0d8d', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=075f0d8d&", function () {
      api.rerender('075f0d8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QDeX9E4o6ykp/JS/comp/starrating.vue"
export default component.exports